import Spine from 'exports-loader?PIXI.spine.Spine!pixi-spine'

export default Spine
